var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content programManagement" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.add } },
              [_vm._v("新增")]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { "background-color": "#fff", "margin-top": "6px" }
          },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", prop: "sorting", width: "50" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划名称", prop: "scheduleName" }
                }),
                _c("el-table-column", {
                  attrs: { label: "机器人名称", prop: "taskName" }
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间", prop: "dateCreated" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划开始日期", prop: "taskDailyStart" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划结束日期", prop: "taskDailyEnd" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                setColorOrange: scope.row.taskState === 0,
                                setColorBlue: scope.row.taskState === 1,
                                setColorGray: scope.row.taskState === 2
                              }
                            },
                            [_vm._v(_vm._s(_vm.taskState(scope.row.taskState)))]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "启动/停止", prop: "startOrStop" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#409eff",
                              "inactive-color": "#97a8be"
                            },
                            on: {
                              change: function($event) {
                                return _vm.start(scope.row)
                              }
                            },
                            model: {
                              value: scope.row.taskRunningState,
                              callback: function($$v) {
                                _vm.$set(scope.row, "taskRunningState", $$v)
                              },
                              expression: "scope.row.taskRunningState"
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { fixed: "right", label: "操作", width: "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              class: [
                                scope.row.taskRunningState === 1
                                  ? "banClick"
                                  : ""
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.editor(scope.row)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.details(scope.row)
                                }
                              }
                            },
                            [_vm._v("详情")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "red" },
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.deletes(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("plan-dialog", {
        ref: "planDialog",
        attrs: { "dialog-form": _vm.dialogForm, "robot-list": _vm.robotList },
        on: { planCancel: _vm.planCancel, nextStep: _vm.nextStep }
      }),
      _c("configuration-dialog", {
        ref: "configurationDialog",
        attrs: { "configuration-form": _vm.configurationForm },
        on: {
          configurationCancel: _vm.configurationCancel,
          lastStep: _vm.lastStep,
          createPlan: _vm.createPlan
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }